export { default as BlockedText } from './component';
